import { MRT_PaginationState } from 'material-react-table';
import { useRef, useState } from 'react';
import { formatDate } from '../utils';

export const useTableFilterMulti = (filterKeys: string[] = []) => {
  // 1. Estado para rango de fechas
  const [dateBefore, setDateBefore] = useState('');
  const [dateAfter, setDateAfter] = useState('');
  const [vendedor, setVendedor] = useState('');

  // 2. Paginación
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  // 3. Objeto dinámico para filtros (ej: { orden_compra: "", factura: "" })
  const [globalFilters1, setGlobalFilters1] = useState<Record<string, string>>(
    filterKeys.reduce((acc, key) => ({ ...acc, [key]: "" }), {})
  );

  // 4. Objeto dinámico para términos de búsqueda (con debounce)
  const [searchTerms1, setSearchTerms1] = useState<Record<string, string>>(
    filterKeys.reduce((acc, key) => ({ ...acc, [key]: "" }), {})
  );

  // 5. Timer para debounce
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  // 6. Función genérica para manejar cualquier filtro
  const onChangeFilter1 = (key: string, value: string) => {
    // Actualiza el valor mostrado en el input
    setGlobalFilters1(prev => ({ ...prev, [key]: value }));

    // Debounce para evitar llamadas excesivas a la API
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setSearchTerms1(prev => ({ ...prev, [key]: value }));
      setPagination({ pageIndex: 0, pageSize: 10 }); // Resetear paginación
    }, 610);
  };

  // 7. Limpiar todos los filtros
  const cleanFilter = () => {
    setGlobalFilters1(
      Object.keys(globalFilters1).reduce((acc, key) => ({ ...acc, [key]: "" }), {})
    );
    setSearchTerms1(
      Object.keys(searchTerms1).reduce((acc, key) => ({ ...acc, [key]: "" }), {})
    );
    setDateBefore('');
    setDateAfter('');
    setVendedor('');
    setPagination({ pageIndex: 0, pageSize: 10 });
  };

  // 8. Manejador de fechas (opcional)
  const onChangeRangeDate = (range: Date[]) => {
    setDateBefore(formatDate(range[0]));
    setDateAfter(formatDate(range[1]));
  };

  return {
    // Estados
    globalFilters1,  // Objeto con todos los valores de los inputs (ej: { orden_compra: "123", factura: "456" })
    searchTerms1,    // Objeto con los términos de búsqueda reales (con debounce)
    pagination,
    dateBefore,
    dateAfter,
    vendedor,
    
    // Funciones
    setPagination,
    onChangeFilter1,  // ¡Única función para manejar todos los filtros!
    onChangeRangeDate,
    cleanFilter,
    setVendedor,
  };
};
export default  useTableFilterMulti;